import { render, staticRenderFns } from "./NotesDrawer.vue?vue&type=template&id=4d13c544"
import script from "./NotesDrawer.vue?vue&type=script&lang=js"
export * from "./NotesDrawer.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports